module.exports = __webpack_public_path__ + "static/media/nvshen-xiangshui.fec67ace.png";